import { render, staticRenderFns } from "./NotificationsTalentAcceptedListItem.vue?vue&type=template&id=a5fe3314&scoped=true&"
import script from "./NotificationsTalentAcceptedListItem.vue?vue&type=script&lang=ts&"
export * from "./NotificationsTalentAcceptedListItem.vue?vue&type=script&lang=ts&"
import style0 from "./NotificationsTalentAcceptedListItem.vue?vue&type=style&index=0&id=a5fe3314&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5fe3314",
  null
  
)

/* custom blocks */
import block0 from "./NotificationsTalentAcceptedListItem.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports